import React from "react";
// Import admin-specific components
import Ticket from "../admin/admincomponent/ticket/Ticket";
export const allAdminroutes = [
  /// Dashboard
  { url: "/", component: <Ticket /> },
  { url: "grievance-management", component: <Ticket /> },
];
